import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down-circle",
  "use": "icon-arrow-down-circle-usage",
  "viewBox": "0 0 16.35 16.35",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.35 16.35\" id=\"icon-arrow-down-circle\"><title>资源 1</title><g id=\"icon-arrow-down-circle_图层_2\" data-name=\"图层 2\"><g id=\"icon-arrow-down-circle_图层_1-2\" data-name=\"图层 1\"><path d=\"M8.18,16.35a8.18,8.18,0,1,1,8.17-8.17A8.18,8.18,0,0,1,8.18,16.35ZM8.18,1a7.18,7.18,0,1,0,7.17,7.18A7.19,7.19,0,0,0,8.18,1Z\" /><path d=\"M8.24,11.14a.94.94,0,0,1-.68-.29L4.4,7.55a.5.5,0,0,1,.72-.69l3.16,3.3,3-3.29a.5.5,0,0,1,.71,0,.51.51,0,0,1,0,.71l-3,3.29a1,1,0,0,1-.69.3Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrow-down-circle.svg
// module id = mqwo
// module chunks = 72